'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/Paperclip.es.js";
const o = a.forwardRef((r, a$1) => /* @__PURE__ */ a.createElement(p, { ref: a$1, ...r, weights: e }));
o.displayName = "PaperclipIcon";
const m = o;
export {
  m as Paperclip,
  o as PaperclipIcon
};
